import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8rugen3wze: FaireBrandEntity = {
  token: "b_8rugen3wze",
  type: "brand",
  name: "Haxan Ferments",
  avatarUrl:
    "https://cdn.faire.com/fastly/eadcdf810bd5d58a371d0db7a4723f52417c594cdfba63df2949caf149a7b852.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a30db63ab5c75ab71a5733f42a272f690a89f9d41b7c930a031c761c095218a8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eadcdf810bd5d58a371d0db7a4723f52417c594cdfba63df2949caf149a7b852.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a30db63ab5c75ab71a5733f42a272f690a89f9d41b7c930a031c761c095218a8.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 8,
  isInsider: true,
  description:
    "Häxan Ferments started with a question a molecular biologist probably shouldn't ask in her home kitchen: what if we let this get a little weird?\nJessica Huszar spent years studying transformation at the molecular level before turning that same curiosity toward fermentation. In 2018, she founded Häxan Ferments in Seattle, turning her home experiments into a line of naturally fermented hot sauces and raw vinegars built on Pacific Northwest ingredients.\nEvery product starts with a relationship — with farms like Tonnemaker, Alvarez Organic, Tualco, and Radicle Roots, whose produce we ferment slowly, often for months, until it becomes something genuinely different from anything you'll find on a typical shelf. No shortcuts, no artificial anything. Just time and good ingredients doing the work.\nHäxan has been featured in the New York Times, The Kitchn, and the Seattle Times, and is carried at Whole Foods and PCC locations across Washington and Oregon, along with 100+ specialty retailers nationwide. Our products have also been recognized by the Good Food Awards and the Screaming Mimis Hot Sauce Awards.\nWe named the company after a 1922 film about witchcraft — a nod to the alchemy of fermentation, and the slightly wild transformation that happens when good ingredients are given the time to become something extraordinary.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:56.474Z",
    importedBy: "entity-db-cli",
  },
};
